import { useMemo } from "react";
import {
  InternalAdminOrganizationQuery,
  InternalAdminOrganizationQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_ORGANIZATION_QUERY from "../_networking/internal-admin-organization";

const useInternalAdminOrganizations = (id: string | string[] | undefined) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading, refetch } = useQuery<
    InternalAdminOrganizationQuery,
    InternalAdminOrganizationQueryVariables
  >(INTERNAL_ADMIN_ORGANIZATION_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const organizations = useMemo(() => {
    if (!data) return [];
    return data.internalAdminOrganization;
  }, [data]);

  const organization = useMemo(() => {
    if (organizations && organizations.length === 1) {
      return organizations[0];
    }
    return undefined;
  }, [organizations]);

  return {
    organization,
    organizations,
    loading,
    refetch,
  };
};

export default useInternalAdminOrganizations;
